import { mapActions, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import Utils from '@/util'
import { PRESENTATION_TRIGGERS } from '@/constant/eventActions/PresentationsEventActions'

export default {
  computed: {
    ...mapState({
      isCreatingNewPresentation: (state) => state.isCreatingNewPresentation,
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    ...mapActions(['patchPresentationAction', 'setSlideSearchPopupVisibilityAction']),
    ...mapActions(['createNewPresentationAction', 'setErrorOnInternalServerAction', 'setCurrentUserHasCreatedPresentationAction']),
    ...mapActions('blankPresentation', ['setCreatedPresentationFromOnBoardingAction']),
    createNewPresentation(trigger, queryParams = {}) {
      try {
        if (this.isCreatingNewPresentation) {
          return
        }
        this.createNewPresentationAction({
          trigger,
          onSuccess: this.onCreateNewPresentationSuccess,
          onFailure: this.onCreateNewPresentationFailure,
          queryParams,
        })
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    async createNewPresentationV2(trigger, queryParams = {}, apiPayload = {}) {
      try {
        if (this.isCreatingNewPresentation) {
          return
        }
        await this.createNewPresentationAction({
          trigger,
          onSuccess: this.onCreateNewPresentationSuccessV2,
          onFailure: this.onCreateNewPresentationFailure,
          queryParams,
          apiPayload,
        })
        if (trigger === PRESENTATION_TRIGGERS.FROM_ONBOARDING) {
          this.setCreatedPresentationFromOnBoardingAction(true)
        }
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    // eslint-disable-next-line no-unused-vars
    async onCreateNewPresentationSuccess() {
      this.setCurrentUserHasCreatedPresentationAction()
    },
    async onCreateNewPresentationSuccessV2() {
      await this.setCurrentUserHasCreatedPresentationAction()
      this.setSlideSearchPopupVisibilityAction(true)
      this.patchPresentationAction({
        isShowingSlideSearch: true,
      })
    },
    onCreateNewPresentationFailure(error) {
      if (error && error.body && error.body.message) {
        return Utils.showToastError(error.body.message)
      }
      if (error && error.body && error.body.errors) {
        return Utils.showToastError(JSON.stringify(error.body.errors))
      }
      Sentry.captureException(error)
      return this.setErrorOnInternalServerAction('Cannot create presentation')
    },
  },
}
